export default {
    data() {
        return {
            uri: ''
        };
    },

    methods: {
        getFilter() {
            this.uri = "";

            if (this.selectedDateRange) {
                this.uri += "?start-date=" + moment(this.selectedDateRange.start).format('l') + "&end-date=" + moment(this.selectedDateRange.end).format('l');
            } else {
                this.uri += "?start-date=&end-date=";
            }

            if (this.selectedUser) {
                if(['general', 'master', 'sale', 'products', 'client', 'contract', 'foundation','quotes', 'computerEase'].includes(this.tabName)){
                    this.uri += "&user=" + JSON.stringify(this.selectedUser.map((element)=>element.id));
                } else {
                    this.uri += "&user=" + this.selectedUser.id;
                }
            }

            if (this.selectedContractType) {
                if(['general', 'master', 'sale', 'products', 'client', 'contract', 'foundation','quotes', 'computerEase'].includes(this.tabName)){
                    this.uri += "&contract-type=" + JSON.stringify(this.selectedContractType.map((element)=>element.id));
                } else {
                    this.uri += "&contract-type=" + this.selectedContractType.id;
                }
            }

            if (this.selectedOffices) {
                this.uri += "&office=" + JSON.stringify(this.selectedOffices.map((element)=>element.id));
            }

            if (this.selectedFixedDateRangeIdentifier) {
                this.uri += "&fixed-date-range-identifier=" + this.selectedFixedDateRangeIdentifier.id;
            }

            if (this.selectedStage) {
                this.uri += "&stage=" + this.selectedStage.id;
            }
        },

        getQueryParams() {
            const urlParams = new URLSearchParams(window.location.search);
            this.uri = "";

            if (urlParams.get('start-date') && urlParams.get('end-date')) {
                this.uri += "?start-date=" + urlParams.get('start-date') + "&end-date=" + urlParams.get('end-date');
            } else {
                this.uri += "?start-date=&end-date=";
            }

            if (this.selectedReport) {
                if(this.selectedReport.id.includes('excel')){
                    this.uri += '&name=' + this.selectedReport.name.replace(/[^\w\s]/gi, '');
                } else {
                    this.uri += '&name=' + this.selectedReport.name;
                }
            } else {
                if (urlParams.get('name')) {
                    this.uri += "&name=" + urlParams.get('name');
                }
            }

            if (urlParams.get('user')) {
                this.uri += "&user=" + urlParams.get('user');
            }

            if (urlParams.get('contract-type')) {
                this.uri += "&contract-type=" + urlParams.get('contract-type');
            }

            if (urlParams.get('office')) {
                this.uri += "&office=" + urlParams.get('office');
            }

            if (urlParams.get('sales_status')) {
                this.uri += "&sales_status=" + urlParams.get('sales_status');
            }

            if (urlParams.get('marketing_status')) {
                this.uri += "&marketing_status=" + urlParams.get('marketing_status');
            }

            if (urlParams.get('type')) {
                this.uri += "&type=" + urlParams.get('type');
            }
        },

        createPop(url, name)
        {
            let newwindow = window.open(url,name,'location=0,width=860,height=740,toolbar=0,menubar=0,location=0');
            if (window.focus) {newwindow.focus()}
        },
        getFieldLabel(labels, slug) {
            if(labels && labels.hasOwnProperty(slug)){
                return labels[slug];
            }else{
                return slug.replace('-', ' ').toUpperCase();
            }
        },

        checkValidations(path){
            let requiredFieldErrors = {
                user: null,
                start_date: null,
                end_date: null,
                stage: null
            };

            const url = new URL(window.location.origin+''+path)
            const urlParams = new URLSearchParams(url.search);
            if(!urlParams.get('start-date') || !urlParams.get('end-date') || (JSON.parse(urlParams.get('user')).length === 0 && !this.isPm) || (!urlParams.get('stage') && this.isPm)) {
                if (JSON.parse(urlParams.get('user')).length === 0 && !this.isPm) {
                    requiredFieldErrors.user = 'User is required';
                }
                if (!urlParams.get('stage') && this.isPm) {
                    requiredFieldErrors.stage = 'Stage is required';
                }
                if (!urlParams.get('start-date')) {
                    requiredFieldErrors.start_date = 'Start date is required';
                }
                if (!urlParams.get('end-date')) {
                    requiredFieldErrors.end_date = 'End date is required';
                }
                Bus.$emit('filterFieldsRequired', requiredFieldErrors);
                return true;
            } else {
                Bus.$emit('filterFieldsRequired', requiredFieldErrors);
            }
        },

        getQrveyDatasetRLS(callback = null) {
            axios.post(route('api.qrvey.get-rls'))
                .then((response) => {

                    if (typeof callback === 'function') {
                        callback(response.data.permission);
                    }
                })
                .catch(error => {
                    console.log("qrvey get rls error", error);
                    if (typeof callback === 'function') {
                        callback(null, error);
                    }
                });
        },

        getJWTForQrvey(body) {
            const GENERATE_URL = 'https://gxwvn.qrveyapp.com/devapi/v4/core/login/token';
            const GENERATE_CONFIG = {
                headers: {
                    'x-api-key': 'Fz09i7eNMAbluwbt43Te4ADzwxl2EylOGH5EwTjs',
                    'Content-Type': 'application/json'
                }
            };
            return axios
                .post(GENERATE_URL, body, GENERATE_CONFIG)
                .then(response => response.data.token)
                .catch(error => console.log('generateToken ->', error));
        },

        loadQrveyPageWidget(team, pageId, qrveyContainer, builder = false, singlePageEdit = false, personalization = false, clientId = null) {

            console.log("pageId => ",pageId, "builder => " ,builder, "clientId => " , clientId);
            let pageConfig ={
                domain: 'https://gxwvn.qrveyapp.com',
                app_id: team.qrvey_app_id,
                user_id: team.qrvey_app_owner_id,
                qv_token: "",
                dashboard_id: "",
                single_page_edit: singlePageEdit,
                featurePermission: {},
                personalization: {
                    enabled: personalization,
                }
            }

            this.getQrveyDatasetRLS((rlsPermissions, error) => {
                if (error) {
                    console.error("An error occurred while fetching RLS permissions:", error);
                    return;
                }

                let permissions = rlsPermissions;
                if (builder) {
                    pageConfig.asset_permissions = {
                        pages: {
                            page_ids: [
                                pageId
                            ]
                        }
                    }
                }
                pageConfig.dashboard_id = pageId;
                pageConfig.page_id = pageId;
                pageConfig.featurePermission = {
                    navigation: {
                        hideNavigationTab: true,
                    },
                    userManagement: {
                        hideUserManagementTab: true
                    },
                    pagesAndApplication: {
                        hidePublishAppButton: true,
                        hidePublishPageButton: true,
                        hideCopyPageLink: true,
                        hideLaunchButton: true,
                        hideCreateManagePages: true,
                        hidePageStatus: true,
                        hidePagesBar: true
                    },
                    hideManageCanvas: true
                }

                let qrveyJWTBody = {
                    userid: team.qrvey_app_owner_id,
                    appid: team.qrvey_app_id,
                    permissions
                }
                if(clientId){
                    qrveyJWTBody.clientid = clientId
                }


                this.getJWTForQrvey(qrveyJWTBody)
                    .then(res => {
                        console.log("qrvey JWT response", res)
                        pageConfig.qv_token = res;
                        this.buildQrveyPage(qrveyContainer, pageConfig, builder, clientId == null);
                    });
            });
        },
        buildQrveyPage(qrveyContainer, pageConfig, builder, isOwner = false) {
            setTimeout(() => {
                let page_view_tag = (!builder || !isOwner) ? document.createElement("qrvey-end-user") : document.createElement("qrvey-builders");
                console.log("qrvey page setting", pageConfig);
                page_view_tag.setAttribute("settings", JSON.stringify(pageConfig));
                qrveyContainer.append(page_view_tag);

                this.$nextTick(() => {
                    $('.navbar.sticky-top').css("position", "relative")
                });
            }, 500);
        }
    },
};
